import { apiFetch } from '$lib/api/helpers';
import type { DINChannelPatch, DINChannelResponse } from '$lib/types/din_channel';

const PATH = '/din_channels/';

export async function fetchDINChannels() {
  return apiFetch<Array<DINChannelResponse>>(PATH);
}

export async function fetchDINChannelsByModule(moduleId: number) {
  return apiFetch<Array<DINChannelResponse>>(`${PATH}?din_module_id=${moduleId}`);
}

export async function fetchDINChannelById(id: number) {
  return apiFetch<DINChannelResponse>(`${PATH}${id}/`);
}

export async function createDINChannel(data: {
  din_module: number;
  channel_number: number;
  bus_no?: number | null;
  load?: number | null;
}) {
  return apiFetch<DINChannelResponse>(PATH, {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export async function updateDINChannel(
  id: number,
  data: Partial<{
    din_module: number;
    channel_number: number;
    bus_no: number | null;
    load: number | null;
  }>
) {
  return apiFetch<DINChannelResponse>(`${PATH}${id}/`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
}

export async function patchDINChannel(id: number, patch: DINChannelPatch) {
  return apiFetch<DINChannelResponse>(`${PATH}${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(patch)
  });
}

export async function deleteDINChannel(id: number) {
  return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}
